import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    minHeight: '100vh',
    fontWeight: 200,
    color: '#fff',
    height: '100%',
  },
  headerItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  stakeHeader: {
    fontSize: 14,
    color: theme.palette.secondary.dark,
  },
  stakeHeaderTitle: {
    fontSize: 14,
    color: theme.palette.secondary.dark,
  },
  headerContent: {
    display: 'grid',
  },
  pkr: {
    padding: '10px 12px',
    fontWeight: 'bold',
    backgroundColor: theme.palette.dark,
    color: 'rgba(194, 195, 197, 0.65)',
    textAlign: 'center',
    lineHeight: 2,
    borderRadius: 10,
  },
  input: {
    flex: 1,
    margin: '8px 0',
    marginLeft: 12,
  },
  max: {
    color: theme.palette.primary.main,
  },
  splitter: {
    color: theme.palette.secondary.dark,
  },
  '@keyframes slide': {
    '0%, 100%': { left: 0 },
    '50%': { left: 4 },
  },
  terms: {
    cursor: 'pointer',
    color: theme.palette.primary.main,
  },
  alignCenter: {
    textAlign: 'center',
  },
  endsBlock: {
    display: 'flex',
    alignItems: 'center',
  },
  warningMessage: {
    height: 120,
    padding: 45,
    textAlign: 'center',
  },

  //new
  note: {
    fontSize: 20,
    fontWeight: 200,
    zIndex: 1,
    margin: 0,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  title: {
    color: '#e5b839',
    fontWeight: 200,
    marginLeft: 10,
    padding: 10,
  },
  mainHeader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
  },
  textLine: {
    width: 140,
    height: 1,
    backgroundColor: 'rgba(255, 255, 255, .2)',
    margin: '35px 0 40px 0',
  },
  flexColumn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  flexBox: {
    marginBottom: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto',
    zIndex: 1,
  },
  bgAnimation: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: '100vw',
    height: '100vh',
  },
  stars2: {
    width: 2,
    height: 2,
    background: 'transparent',
    boxShadow:
      '100vw 1306px #FFF , 62vw 1783px #FFF , 55vw 1085px #FFF , 65vw 920px #ee57a8 , 422px 1233px #FFF , 387px 98px #FFF , 50vw 637px #FFF , 1084px 782px #ee57a8 , 476px 453px #FFF , 72vw 1306px #ee57a8 , 60px 1086px #FFF , 72vw 1575px #FFF , 272px 1684px #ee57a8 , 1285px 750px #FFF , 1416px 1327px #ee57a8 , 1931px 473px #FFF , 736px 1395px #ee57a8 , 1816px 763px #FFF , 438px 879px #FFF , 665px 1902px #FFF , 1341px 677px #ee57a8 , 1404px 1073px #FFF , 100px 597px #ee57a8 , 357px 1689px #FFF , 60vw 1342px #ee57a8 , 1954px 502px #FFF , 1192px 1308px #FFF , 540px 1239px #FFF , 1360px 552px #FFF , 89px 752px #FFF , 88vw 1253px #FFF , 62px 517px #FFF , 1375px 1705px #FFF , 1343px 1511px #FFF , 1659px 1922px #FFF , 1560px 289px #FFF , 72vw 1799px #FFF , 1886px 1480px #ee57a8 , 1718px 1885px #FFF , 824px 738px #FFF , 72vw 1370px #FFF , 1781px 1171px #ee57a8 , 88vw 273px #ee57a8 , 1197px 120px #FFF , 213px 7px #FFF , 1226px 1920px #FFF , 1844px 207px #e6007a , 1675px 970px #FFF , 1435px 1283px #FFF , 37px 353px #ee57a8 , 59px 417px #FFF , 76vw 1602px #e6007a , 1549px 1490px #FFF , 73vw 1845px #FFF , 1328px 198px #FFF , 1050px 1149px #e6007a , 77vw 711px #FFF , 333px 263px #e6007a , 342px 1508px #FFF , 77vw 1810px #FFF , 1377px 1558px #FFF , 890px 487px #FFF , 1081px 759px #FFF , 890px 1515px #FFF , 911px 1284px #FFF , 335px 735px #e6007a , 88vw 549px #FFF , 1239px 1064px #FFF , 226px 71px #FFF , 1100px 1278px #e6007a , 1851px 1805px #FFF , 1370px 1999px #FFF , 1008px 1122px #FFF , 785px 813px #FFF , 1358px 601px #e6007a , 1833px 1305px #FFF , 1768px 1304px #e6007a , 1303px 532px #FFF , 860px 598px #FFF , 1329px 593px #e6007a , 1038px 1088px #FFF , 88vw 405px #FFF , 965px 82px #FFF , 1483px 1438px #ee57a8 , 310px 1479px #FFF , 1786px 1500px #FFF , 1866px 852px #FFF , 18px 1757px #e6007a , 88vw 1004px #FFF , 1542px 1933px #FFF , 633px 1970px #FFF , 93vw 1713px #FFF , 175px 28px #FFF , 592px 894px #FFF , 121px 1162px #FFF , 1601px 1567px #FFF , 93vw 657px #FFF , 640px 1233px #FFF , 1073px 1255px #FFF , 840px 1087px #ee57a8 , 718px 250px #FFF , 967px 709px #FFF , 731px 239px #FFF , 1623px 593px #ee57a8 , 1058px 1820px #FFF , 516px 1898px #FFF , 666px 12px #ee57a8 , 1997px 1382px #FFF , 112px 1690px #FFF , 687px 1309px #FFF , 63px 539px #e6007a , 185px 1897px #FFF , 1055px 1691px #FFF , 435px 1517px #e6007a , 93vw 1119px #FFF , 1721px 133px #FFF , 1212px 47px #e6007a , 166px 18px #FFF , 1416px 1652px #FFF , 1409px 1745px #ee57a8 , 1357px 1232px #FFF , 1677px 1998px #ee57a8 , 448px 1415px #FFF , 705px 1736px #FFF , 1031px 1466px #FFF , 543px 78vw #ee57a8 , 1592px 1888px #FFF , 1749px 1175px #FFF , 639px 1114px #FFF , 1591px 508px #ee57a8 , 759px 1244px #FFF , 824px 380px #FFF , 942px 955px #FFF , 723px 732px #FFF , 113px 1369px #ee57a8 , 203px 1739px #FFF , 868px 733px #FFF , 713px 971px #FFF , 341px 833px #ee57a8 , 762px 824px #FFF , 93vw 310px #FFF , 1858px 1349px #FFF , 1531px 692px #FFF , 1075px 1512px #e6007a , 93vw 142px #FFF , 1912px 1478px #FFF , 1810px 1078px #FFF , 426px 844px #FFF , 1426px 588px #e6007a , 1909px 654px #FFF , 1107px 295px #FFF , 1351px 527px #e6007a , 1393px 599px #FFF , 93vw 1068px #FFF , 228px 1846px #e6007a , 1271px 374px #FFF , 1348px 612px #FFF , 7px 1301px #FFF , 70vw 1782px #FFF , 1795px 423px #FFF , 1475px 1918px #FFF , 92vw 1861px #FFF , 1624px 51px #FFF , 1791px 672px #FFF , 1594px 1467px #FFF , 90vw 1603px #FFF , 919px 850px #FFF , 523px 609px #FFF , 1196px 207px #FFF , 85vw 410px #FFF , 686px 1097px #FFF , 1570px 133px #e6007a , 1996px 1137px #FFF , 96vw 116px #FFF , 1015px 462px #e6007a , 76px 1143px #FFF , 491px 1818px #FFF , 1563px 795px #FFF , 982px 1721px #FFF , 831px 1204px #FFF , 1737px 589px #e6007a , 95vw 1579px #FFF , 1666px 130px #FFF , 76vw 1799px #FFF , 726px 1519px #FFF , 87vw 1208px #FFF , 1184px 1057px #FFF , 85vw 451px #FFF , 896px 594px #e6007a , 35px 893px #FFF , 895px 542px #FFF , 706px 225px #e6007a , 95vw 1040px #FFF , 1954px 108px #FFF , 98vw 1423px #FFF , 26px 2881px #FFF , 90vw 1564px #FFF , 91vw 2708px #e6007a , 40px 31px #FFF , 98vw 108px #FFF',
    animation: '$animStar 100s linear infinite',
    opacity: 0.5,
    '&:after': {
      content: '""',
      position: 'absolute',
      top: 2000,
      width: 2,
      height: 2,
      background: 'transparent',
      boxShadow:
        '1117px 1306px #FFF , 62vw 1783px #FFF , 55vw 1085px #ee57a8 , 65vw 920px #FFF , 422px 1233px #FFF , 387px 98px #FFF , 50vw 637px #FFF , 1084px 782px #ee57a8 , 476px 453px #FFF , 72vw 1306px #ee57a8 , 60px 1086px #FFF , 72vw 1575px #FFF , 272px 1684px #ee57a8 , 1285px 750px #FFF , 1416px 1327px #ee57a8 , 1931px 473px #FFF , 736px 1395px #ee57a8 , 1816px 763px #FFF , 438px 879px #FFF , 665px 1902px #FFF , 1341px 677px #FFF , 1404px 1073px #FFF , 100px 597px #ee57a8 , 357px 1689px #FFF , 60vw 1342px #FFF , 1954px 502px #FFF , 1192px 1308px #ee57a8 , 540px 1239px #FFF , 1360px 552px #FFF , 89px 752px #FFF , 88vw 1253px #FFF , 62px 517px #FFF , 1375px 1705px #FFF , 1343px 1511px #FFF , 1659px 1922px #FFF , 1560px 289px #ee57a8 , 72vw 1799px #FFF , 1886px 1480px #FFF , 1718px 1885px #ee57a8 , 824px 738px #FFF , 72vw 1370px #ee57a8 , 1781px 1171px #FFF , 88vw 273px #FFF , 1197px 120px #FFF , 213px 7px #e6007a , 1226px 1920px #FFF , 1844px 207px #FFF , 1675px 970px #FFF , 1435px 1283px #FFF , 37px 353px #FFF , 59px 417px #e6007a , 76vw 1602px #ee57a8 , 1549px 1490px #FFF , 73vw 1845px #e6007a , 1328px 198px #FFF , 1050px 1149px #FFF , 77vw 711px #FFF , 333px 263px #e6007a , 342px 1508px #FFF , 77vw 1810px #FFF , 1377px 1558px #e6007a , 890px 487px #FFF , 1081px 759px #FFF , 890px 1515px #FFF , 911px 1284px #e6007a , 335px 735px #FFF , 88vw 549px #FFF , 1239px 1064px #FFF , 226px 71px #FFF , 1100px 1278px #FFF , 1851px 1805px #e6007a , 1370px 1999px #FFF , 1008px 1122px #FFF , 785px 813px #e6007a , 1358px 601px #FFF , 1833px 1305px #e6007a , 1768px 1304px #FFF , 1303px 532px #FFF , 860px 598px #e6007a , 1329px 593px #FFF , 1038px 1088px #ee57a8 , 88vw 405px #FFF , 965px 82px #FFF , 1483px 1438px #e6007a , 310px 1479px #e6007a , 1786px 1500px #FFF , 1866px 852px #e6007a , 18px 1757px #FFF , 88vw 1004px #FFF , 1542px 1933px #FFF , 633px 1970px #FFF , 93vw 1713px #FFF , 175px 28px #FFF , 592px 894px #FFF , 121px 1162px #FFF , 1601px 1567px #FFF , 93vw 657px #FFF , 640px 1233px #FFF , 1073px 1255px #FFF , 840px 1087px #FFF , 718px 250px #FFF , 967px 709px #ee57a8 , 731px 239px #FFF , 1623px 593px #ee57a8 , 1058px 1820px #FFF , 516px 1898px #ee57a8 , 666px 12px #FFF , 1997px 1382px #ee57a8 , 112px 1690px #FFF , 687px 1309px #FFF , 63px 539px #FFF , 185px 1897px #e6007a , 1055px 1691px #FFF , 435px 1517px #FFF , 93vw 1119px #FFF , 1721px 133px #e6007a , 1212px 47px #FFF , 166px 18px #FFF , 1416px 1652px #FFF , 1409px 1745px #FFF , 1357px 1232px #FFF , 1677px 1998px #FFF , 448px 1415px #FFF , 705px 1736px #e6007a , 1031px 1466px #FFF , 543px 1651px #FFF , 1592px 1888px #FFF , 1749px 1175px #FFF , 639px 1114px #FFF , 1591px 508px #ee57a8 , 759px 1244px #FFF , 824px 380px #FFF , 942px 955px #ee57a8 , 723px 732px #FFF , 113px 1369px #FFF , 203px 1739px #FFF , 868px 733px #ee57a8 , 713px 971px #FFF , 341px 833px #FFF , 762px 824px #ee57a8 , 93vw 310px #FFF , 1858px 1349px #FFF , 1531px 692px #FFF , 1075px 1512px #e6007a , 93vw 142px #FFF , 1912px 1478px #FFF , 1810px 1078px #FFF , 426px 844px #FFF , 1426px 588px #e6007a , 1909px 654px #FFF , 1107px 295px #FFF , 1351px 527px #e6007a , 1393px 599px #FFF , 93vw 1068px #e6007a , 228px 1846px #FFF , 1271px 374px #FFF , 1348px 612px #FFF , 7px 1301px #FFF , 70vw 1782px #FFF , 1795px 423px #FFF , 1475px 1918px #FFF , 92vw 1861px #FFF , 1624px 51px #FFF , 1791px 672px #FFF , 1594px 1467px #FFF , 90vw 1603px #FFF , 919px 850px #FFF , 523px 609px #FFF , 1196px 207px #e6007a , 85vw 410px #e6007a , 686px 1097px #FFF , 1570px 133px #FFF , 1996px 1137px #e6007a , 96vw 116px #FFF , 1015px 462px #FFF , 76px 1143px #FFF , 491px 1818px #e6007a , 1563px 795px #FFF , 982px 1721px #FFF , 831px 1204px #FFF , 1737px 589px #FFF , 95vw 1579px #FFF , 1666px 130px #FFF , 76vw 1799px #FFF , 726px 1519px #FFF , 87vw 1208px #FFF , 1184px 1057px #e6007a , 85vw 451px #FFF , 896px 594px #FFF , 35px 893px #FFF , 895px 542px #FFF , 706px 225px #FFF , 95vw 1040px #FFF , 1954px 108px #e6007a , 98vw 1423px #e6007a , 26px 2881px #FFF , 90vw 1564px #e6007a , 91vw 2708px #FFF , 40px 31px #FFF , 98vw 108px #FFF',
    },
  },
  '@keyframes animStar': {
    from: {
      transform: 'translateY(0px)',
    },
    to: {
      transform: 'translateY(-1500px)',
    },
  },
  upperLogo: {
    fill: '#e5b839',
    fillOpacity: '0.15',
    fillRule: 'evenodd',
    padding: '45px 0 0 0',
  },
  grayText: {
    color: '#999999',
    fontSize: 18,
  },
  padded: {
    padding: 10,
  },
  button: {
    textDecoration: 'none',
    fontSize: 18,
    backgroundColor: theme.palette.button.main,
    color: theme.palette.secondary.main,
    textAlign: 'center',
    padding: '10px 5px 10px 5px',
    borderRadius: 10,
    transition: '.1s',
    cursor: 'pointer',
    maxWidth: 200,
    fontWeight: 200,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.button.secondary,
    },
  },
  connect: {
    marginTop: 10,
  },
  center: {
    marginTop: 100,
  },
  content: {
    alignContent: 'center',
    display: 'flex',
    width: '100%',
  },
  headerRoot: {
    backgroundColor: 'rgba(0, 0, 0, .25)',
    borderRadius: 20,
    alignItems: 'center',
  },
  noteBody: {
    backgroundColor: 'rgba(0, 0, 0, .25)',
    borderRadius: 20,
    padding: '30px 20px',
    fontSize: 16,
  },
  connectedWallet: {
    color: theme.palette.white,
    padding: 0,
    fontSize: 15,
  },
  connectedWalletContainer: {
    paddingRight: 20,
  },
  disconnect: {
    color: theme.palette.primary.main,
    fontSize: 15,
    padding: 0,
  },
  enablePoolBtnContainer: {
    justifyContent: 'center',
  },
  termsContainer: {
    justifyContent: 'center',
    display: 'flex',
    marginTop: 25,
  },
  enablePoolBtn: {
    fontSize: 18,
    backgroundColor: theme.palette.primary.main,
    maxWidth: 200,
    borderRadius: 10,
    padding: '10px 5px 10px 5px',
    transition: '.1s',
    marginTop: 50,
    marginBottom: 10,
    '&:disabled': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.secondary.dark,
    },
  },
  cbox: {
    fontSize: 12,
  },
  countdown: {
    marginLeft: 8,
    display: 'flex',
    color: theme.palette.primary.main,
  },
  stakeContent: {
    display: 'grid',
  },
  paper: {
    display: 'grid',
    padding: 10,
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '2px solid #59434f',
    borderRadius: 10,
    textAlign: 'left',
    height: '100%',
  },
  titleHeader: {
    width: '100%',
  },
  paperHeader: {
    fontSize: 18,
    fontWeight: 400,
  },
  modalRoot: {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 30,
    backgroundColor: 'rgba(29, 25, 27, 1)',
    overflow: 'hidden',
    padding: 50,
    width: 'fit-content',
    maxWidth: 413,
  },
  modalHeader: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  modalHeaderClose: {
    cursor: 'pointer',
  },
  modalTitle: {
    alignSelf: 'start',
    marginTop: 20,
    color: theme.palette.secondary.dark,
  },
  balance: {
    fontSize: 14,
    marginTop: 5,
    alignSelf: 'flex-end',
  },
  confirmButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    width: '100%',
    maxWidth: 200,
    borderRadius: 10,
    margin: '0px auto',
    marginTop: 50,
    fontSize: 18,
    transition: '.1s',
    padding: '10px 5px 10px 5px',
    '&:disabled': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.secondary.dark,
    },
  },
  noteDeposit: {
    color: theme.palette.secondary.main,
    fontSize: 14,
    opacity: '0.5',
    marginTop: 20,
  },
  inputRoot: {
    display: 'flex',
    width: '100%',
    borderRadius: 10,
    alignItems: 'center',
    backgroundColor: theme.palette.dark,
  },
  stakeButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    '& > button:nth-child(2)': {
      marginLeft: 16,
    },
  },
  stakeButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    borderRadius: 10,
    fontSize: 18,
    fontWeight: 200,
    maxWidth: 200,
    textDecoration: 'none',
    width: '100%',
    padding: '10px 20px',
  },
  startStakingBtn: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 10,
    fontSize: 18,
    textDecoration: 'none',
    padding: '10px 20px',
    '&:disabled': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.secondary.dark,
    },
  },
  paperStakeContent: {
    flex: 1,
  },
  loadingMargin: {
    marginBottom: 10,
  },
  loadingText: {
    position: 'relative',
    top: '50%',
    transform: 'translateY(-50%)',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 30,
    backgroundColor: 'rgba(29, 25, 27, .8)',
    overflow: 'hidden',
    padding: 50,
    width: 'fit-content',
    color: theme.palette.secondary.main,
  },
  loaderModal: {
    backgroundColor: 'rgba(130, 130, 130, 0.5)',
    '& $div': {
      backgroundColor: 'transparent !important',
    },
  },
  countdownTimer: {
    fontSize: 25,
    margin: '20px 0',
    flexDirection: 'row',
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
  },
  timeContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 8px',
  },
  time: {
    fontSize: 24,
  },
  timeSeparator: {
    fontSize: 24,
  },
  timeLabel: {
    fontSize: 14,
  },
  modalContainer: {
    paddingLeft: 200,
  },
  poolEnded: {
    color: '#e5b839',
    padding: '0 12px',
    width: '100%',
  },
  walletLogo: {
    height: 30,
  },
  walletRoot: {
    width: '60%',
    textAlign: 'center',
  },
  wallets: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    padding: '0px 16px',
  },
  wallet: {
    minWidth: 70,
  },
  walletHeader: {
    margin: '4px 16px',
    fontSize: 14,
  },
  walletLabel: {
    fontSize: 14,
  },
  toggle: {
    marginBottom: 16,
  },
  nftContainer: {
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
  },
  nft: {
    height: 400,
    width: 260,
  },
  logoutRoot: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  logoutButton: {
    color: '#e5b839',
  },
  lightButton: {
    [theme.breakpoints.up('md')]: {
      fontSize: '1',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '.75rem',
    },
    margin: 'auto',
    marginTop: 8,
    border: 'solid 2px #fff',
    borderRadius: 10,
    padding: '8px 0',
    fontWeight: 'bolder',
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.dark,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover svg': {
      position: 'relative',
      animationName: '$slide',
      animationDuration: '0.8s',
      animationTimingFunction: 'linear',
      animationIterationCount: '8',
    },
    '&:disabled': {
      opacity: 0,
    },
  },

  //media queries
  '@media (min-width: 1001px)': {
    stakeContent: {
      gridTemplateColumns: '1.5fr 1fr',
      padding: '40px 20px 10px 20px',
    },
    headerRoot: {
      padding: '60px 80px',
      marginBottom: 60,
    },
    headerContent: {
      gridTemplateColumns: 'repeat(4, auto)',
      gridGap: 60,
    },
  },
  '@media (max-width: 1000px)': {
    stakeContent: {
      gridTemplateColumns: '1fr',
      gridTemplateRows: '1fr 1fr',
      padding: '30px 0px',
    },
    headerRoot: {
      padding: '30px 60px',
      marginBottom: 40,
    },
    headerContent: {
      gridTemplateRows: '1fr 1fr',
      gridGap: 30,
    },
  },
  '@media (max-width: 900px)': {
    coinSection: {
      height: 300,
      '& $img': {
        width: 150,
      },
    },
  },
  '@media (min-width: 571px)': {
    stakeContent: {
      gridGap: 30,
    },
    paper: {
      gridTemplateColumns: '1.5fr auto',
      gridGap: 54,
    },
    headerContent: {
      gridTemplateColumns: 'repeat(2, auto)',
    },
    headerItem: {
      textAlign: 'left',
    },
  },
  '@media (max-width: 570px)': {
    stakeContent: {
      textAlign: 'center',
      gridGap: 10,
      padding: '20px 0px',
    },
    headerRoot: {
      padding: '20px 50px',
      marginBottom: 20,
    },
    paper: {
      gridGap: 20,
      textAlign: 'center',
      justifyItems: 'center',
      gridTemplateRows: '1fr',
      gridTemplateColumns: '1fr',
    },
    headerItem: {
      textAlign: 'center',
    },
    headerContent: {
      justifyContent: 'center',
    },
  },
  '@media (min-width: 501px)': {
    title: {
      fontSize: 30,
    },
    note: {
      padding: 30,
    },
    termsContainer: {
      lineHeight: 3,
      textAlign: 'right',
      flexDirection: 'row',
    },
  },
  '@media (max-width: 500px)': {
    coinSection: {
      height: 220,
      '& $img': {
        width: 100,
      },
    },
    paper: {
      paddingBottom: 20,
      gridGap: 10,
    },
    title: {
      fontSize: 20,
    },
    note: {
      padding: '35px 45px 35px 45px',
    },
    termsContainer: {
      flexDirection: 'column',
      textAlign: 'center',
    },
  },
  '@media (max-width: 400px)': {
    note: {
      padding: '35px 0',
    },
  },
  claimingText: {
    padding: 12,
  },
}));

export default useStyles;
